import axios from 'axios';
import store from '../store';

const routes = {
    backoffice: {
        clientsExport: '/api/v1/backoffice/clients/export',
        clientsImport: '/api/v1/backoffice/clients/import',
        headersTranslationsExport: '/api/v1/backoffice/headers/headerstranslations/export',
        headersTranslationsImport: '/api/v1/backoffice/headers/headerstranslations/import',
        headersConfigurationsExport: '/api/v1/backoffice/headers/headersconfigurations/export',
        headersConfigurationsImport: '/api/v1/backoffice/headers/headersconfigurations/import',
        translationsImport: '/api/v1/backoffice/headers/translations/import',
        translationsExport: '/api/v1/backoffice/headers/translations/export',
        logosImport: '/api/v1/backoffice/headers/logos/import',
        logosExport: '/api/v1/backoffice/headers/logos/export',
        ldapGroupsExport: '/api/v1/backoffice/groups/export',
        ldapGroupsImport: '/api/v1/backoffice/groups/import',
        emailsListExport: '/api/v1/backoffice/emails/export',
        emailsListImport: '/api/v1/backoffice/emails/import',
        iframesBIExport: '/api/v1/backoffice/iframes/bi/export',
        iframesBIImport: '/api/v1/backoffice/iframes/bi/import',
        iframesBPMExport: '/api/v1/backoffice/iframes/bpm/export',
        iframesBPMImport: '/api/v1/backoffice/iframes/bpm/import',
        iframeGenericExport: '/api/v1/backoffice/iframes/iframe/export',
        iframeGenericImport: '/api/v1/backoffice/iframes/iframe/import',
        scopeflowsExport: '/api/v1/backoffice/scopeflows/export',
        scopeflowsImport: '/api/v1/backoffice/scopeflows/import',
        trackTraceDocumentsExport: '/api/v1/backoffice/trackTraceDocuments/export',
        trackTraceDocumentsImport: '/api/v1/backoffice/trackTraceDocuments/import',
        genericSearchImport: '/api/v1/backoffice/genericsearch/import',
        genericSearchExport: '/api/v1/backoffice/genericsearch/export',
        osolKeysImport: '/api/v1/backoffice/osolKeys/import',
        osolKeysExport: '/api/v1/backoffice/osolKeys/export',
        htmlImport: '/api/v1/backoffice/html/import',
        htmlExport: '/api/v1/backoffice/html/export',
        docsPortletsImport: '/api/v1/backoffice/docs/import',
        docsPortletsExport: '/api/v1/backoffice/docs/export'
    },
    bookmarks: {
        getBookmarks: '/api/v1/clients/bookmarks',
        toggleBookmark: '/api/v1/clients/toggleBookmark',
        toggleBookmarkService: '/api/v1/clients/toggleBookmarkService',
        togglePortletBookmark: '/api/v1/clients/togglePortletBookmark',
        getBookmarkedServices: '/api/v1/clients/bookmarkedServices/:clientId',
        getBookmarkedPortlets: '/api/v1/clients/bookmarkedPortlets/:idClient/:serviceName'
    },
    migration: {
        udImport: '/api/v1/backoffice/ud/import',
        udExport: '/api/v1/backoffice/ud/export'
    },
    admin: {
        clients: '/api/v1/clients/',
        refreshLDAPGroups: '/security/refreshgroups',
        isallowed: '/security/isallowed',
        getconfigroles: '/security/getconfigroles',
        getname: '/security/getname',
        osol: '/api/v1/trackandtrace/osol/decrypt',
        allowOsol: '/security/allowOsol',
        logout: '/security/logout'
    },
    config: {
        getHeadersConfig: '/api/v1/clients/config/getHeadersConfig/:configId',
        getGenericSearchHeadersConfig: '/api/v1/clients/config/getGenericSearchHeaders/:clientId',
        getDetailsTabConfig: '/api/v1/clients/config/getDetailsTabConfig/:configId/:scopeflow'
    },
    authentificate: {
        ping: '/security/ping',
        isAuth: '/security/isAuth',
        info: '/security/info'
    },
    trackandtrace: {
        shipments: '/api/v1/trackandtrace/shipments',
        search: '/api/v1/trackandtrace/search/shipments',
        configuration: '/api/v1/trackandtrace/shipments/configuration',
        content: '/api/v1/trackandtrace/search/shipments/content',
        details: '/api/v1/trackandtrace/search/shipments/details',
        events: '/api/v1/trackandtrace/search/shipments/events',
        preview: '/api/v1/trackandtrace/search/shipments',
        document: '/api/v1/trackandtrace/docs/document/:id/:origin',
        documents: '/api/v1/trackandtrace/docs/documents/:id/:clientId/:osol',
        scopeflows: '/api/v1/trackandtrace/scopeflows/getAll/:id',
        previewDoc: '/api/v1/trackandtrace/docs/document/preview/:id/:origin'
    },
    deliveries: {
        deliveries: '/api/v1/deliveries/:type',
        create: '/api/v1/deliveries/create',
        validate: '/api/v1/deliveries/:id/:action'
    },
    genericsearch: {
        allPortlets: '/api/v1/clients/genericsearch/:idClient',
        portlet: '/api/v1/clients/fields/:idClient/:idPortlet',
        config: '/api/v1/genericsearch/init/clientConfig/:clientId/:portletId',
        init: '/api/v1/genericsearch/init',
        search: '/api/v1/genericsearch/search'
    },
    rgpd: {
        submit: '/api/v1/backoffice/emails/send/5'
    },
    BI: {
        iframesBI: '/api/v1/clients/iframes/BI/:clientId',
        iframeBI: '/api/v1/clients/iframes/BI/:clientId/:dashboardId'
    },
    BPM: {
        iframesBPM: '/api/v1/clients/iframes/BPM/:clientId',
        iframeBPM: '/api/v1/clients/iframes/BPM/:clientId/:dashboardId'
    },
    IFRAME: {
        generciIframe: '/api/v1/clients/iframes/IFRAME/:serviceNumber/:clientId/:instanceId'
    },
    docs: {
        authenticate: '/api/v1/docs/authenticate/:client/:clientId/:portletId'
    },
    Statistic: {
        getStatistic: '/api/v1/clients/statistics/:clientName'
    },
    sharepoint: {
        list: '/api/v1/docs/storage/sharepoint/list/:clientId/:portletId',
        info: '/api/v1/docs/storage/sharepoint/info/:clientId/:portletId',
        upload: '/api/v1/docs/storage/sharepoint/upload',
        mkdir: '/api/v1/docs/storage/sharepoint/mkdir',
        rename: '/api/v1/docs/storage/sharepoint/rename',
        delete: '/api/v1/docs/storage/sharepoint/delete',
        search: '/api/v1/docs/storage/sharepoint/search/:clientId/:portletId'
    },
    mail: {
        incident: '/api/v1/backoffice/emails/incident'
    }
};

const catchError = err =>
    store.commit('displayErrors', {
        statusReq: err.response?.status,
        errno: err.response?.data.errno
    });

const api = {
    _getServiceName: () => {
        let pathName = window.location.pathname;
        // to fix postion OSOL in PathName
        if (!pathName.startsWith('/OSOL') && pathName.includes('/OSOL/')) {
            pathName = pathName.replace('/OSOL', '');
        }
        return pathName
            .split('/')
            .map(path => (path && path !== '' ? path : null))
            .filter(path => path !== null)[1];
    },
    _setParams: (url, params) => {
        for (const query in params) {
            url = url?.replace(`:${query}`, params[query]);
        }
        return url;
    },
    _buildURL: function (route, params, service) {
        let serviceName = service;
        if (!service) {
            serviceName = this._getServiceName();
        }
        if (typeof route === 'object') {
            serviceName = route[0];
            route = route[1];
        }
        if (!serviceName) {
            return null;
        }
        let url = routes[serviceName][route];
        if (params) {
            url = this._setParams(url, params);
        }
        return url;
    },
    get: async function (route, params, options, service) {
        let url = this._buildURL(route, params, service);
        if (!url && route[0]) {
            url = routes[route[0]][route[1]];
            if (params) {
                url = this._setParams(url, params);
            }
        }
        const result = await axios.get(`${getOrigin()}${url}`, options).catch(catchError);
        return result?.data || result;
    },
    post: async function (route, params, body, config = {}) {
        if (arguments.length === 2) {
            body = params;
            params = null;
        }
        const url = this._buildURL(route, params);
        const result = await axios.post(`${getOrigin()}${url}`, body, config).catch(catchError);
        return result.data || result;
    },
    patch: async function (route, params, body) {
        if (arguments.length === 2) {
            body = params;
            params = null;
        }
        const url = this._buildURL(route, params);
        const result = await axios.patch(`${getOrigin()}${url}`, body).catch(catchError);
        return result.data || result;
    },
    delete: async function (route, params, options, service) {
        let url = this._buildURL(route, params, service);
        if (!url && route[0]) {
            url = routes[route[0]][route[1]];
            if (params) {
                url = this._setParams(url, params);
            }
        }
        const result = await axios.delete(`${getOrigin()}${url}`, options).catch(catchError);
        return result?.data || result;
    },
    setLang: async function (lang, i18n, vuetify) {
        let translations = {};
        try {
            const translationsRes = await axios.get(`/api/v1/clients/config/getTranslations/${lang}`);
            translations = translationsRes?.data || {};
        } catch (error) {
            console.log('Loading header translations fail : ', error);
        }
        const fromVuetify = require('../../node_modules/vuetify/lib/locale/' + lang).default;
        const messages = {
            ...translations,
            ...fromVuetify
        };
        const msgMap = {};
        msgMap[lang] = messages;
        vuetify.lang.current = lang;
        vuetify.lang.locales = msgMap;
        i18n.setLocaleMessage(lang, messages);
        i18n.locale = lang;
        return messages;
    }
};

function getOrigin() {
    return window.location.origin;
}

export { api };
